module.exports = __webpack_public_path__ + "media/images/iconPaginateLast__okGreen--dark-f1eef60a35b4370a0453f431466f01e0.png";